<template>
  <div id="partner-view">
    <custom-toolbar
      :title="'Détails du partenaire'"
      @refresh="refreshObjet"
    />
    <v-row class="mt-1">
      <v-col cols="12" md="5" lg="4">
        <v-skeleton-loader
          v-show="loading"
          boilerplate
          type="card-avatar, article, article, article, article, actions"
        ></v-skeleton-loader>
        <partner-bio-panel
            v-if="!loading && partner"
            :user-data="partner"
        />
      </v-col>
      <v-col cols="12" md="7" lg="8">
        <v-tabs v-model="tab" show-arrows>
            <v-tab key="referrals">
                <v-icon size="20" class="me-3">{{ icons.mdiShapeOutline }}</v-icon>
                <span>Referrals</span>
            </v-tab>
            <v-tab key="withdrawals">
                <v-icon size="20" class="me-3">{{ icons.mdiCashRefund }}</v-icon>
                <span>Withdrawals</span>
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" class="mt-5 pa-1">
            <v-tab-item key="referrals">
                <partner-referral-list v-if="partner" :partner-id="partner.id" />
            </v-tab-item>
             <v-tab-item key="withdrawals">
                 <partner-withdrawal-list v-if="partner" :partner-id="partner.id" />
            </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  getCurrentInstance, onMounted, ref
} from '@vue/composition-api'
import PartnerBioPanel from '@core/components/user/PartnerBioPanel'
import PartnerReferralList from '@core/components/user/PartnerReferralList'
import PartnerWithdrawalList from '@core/components/user/PartnerWithdrawalList'
import CustomToolbar from '@core/components/toolbar/CustomToolbar'
import store from '@/store'
import { mdiShapeOutline, mdiCashRefund } from '@mdi/js'

export default {
  name: 'PartnerDetails',
  components: {
    CustomToolbar,
    PartnerBioPanel,
    PartnerReferralList,
    PartnerWithdrawalList
  },
  setup() {
    const loading = ref(false)
    const tab = ref(null)
    const route = getCurrentInstance().proxy.$route

    const partner = ref(null)

    const getPartner = () => {
      const id = route.params.id !== undefined ? route.params.id : null
      if (id !== null) {
          loading.value = true
          store.dispatch('user/getPartner', id).then(() => {
            partner.value = store.state.user.user // Assuming getPartner sets state.user.user
            loading.value = false
          }).catch(error => {
            console.log(error)
          })
      }
    }

    const refreshObjet = () => {
      getPartner()
    }

    onMounted(() => {
      getPartner()
    })

    return {
      loading,
      partner,
      tab,
      refreshObjet,
      icons: {
          mdiShapeOutline,
          mdiCashRefund
      }
    }
  },
}
</script>
